import type {State} from 'src/reducers';
import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {
  HiringPipelineFilters,
  SavedDashboardList,
  SelectedInterviewFilterColumnsData,
  SelectedJobStatusFilterColumnsData,
  SelectedPipelineVelocityFilterColumnsData,
  SelectedPipelineVelocityDrilldownFilterColumnsData,
} from 'src/types/analytics-genesis';


export const selectJobFilters = (state: State): HiringPipelineFilters =>
  state.analyticsHiringPipeline.selectedJobFilters;

export const selectDashboardID = (state: State): string | null | undefined =>
  state.analyticsHiringPipeline.currentDashboardID;

export const selectDateRange = (state: State): DateRangeWithTimezone =>
  state.analyticsHiringPipeline.selectedDateRange;

export const selectSavedDashboards = (state: State): SavedDashboardList =>
  state.analyticsHiringPipeline.savedDashboards;

export const selectJobStatusTableColumnFilterData = (
  state: State,
): SelectedJobStatusFilterColumnsData =>
  // @ts-expect-error - TS2339 - Property 'jobStatusAgeTableColumnFilter' does not exist on type 'AnalyticsHiringPipelineState'.
  state.analyticsHiringPipeline.jobStatusAgeTableColumnFilter ?? {};

export const selectInterviewScheduleTableColumnFilterData = (
  state: State,
): SelectedInterviewFilterColumnsData =>
  // @ts-expect-error - TS23339 - Property 'interviewScheduleTableColumnFilter' does not exist on type 'AnalyticsHiringPipelineState'.
  state.analyticsHiringPipeline.interviewScheduleTableColumnFilter ?? {};

export const selectPipelineVelocityTableColumnFilterData = (
  state: State,
): SelectedPipelineVelocityFilterColumnsData =>
  // @ts-expect-error - TS23339 - Property 'pipelineVelocityTableColumnFilter' does not exist on type 'AnalyticsHiringPipelineState'.
  state.analyticsHiringPipeline.pipelineVelocityTableColumnFilter ?? {};

export const selectPipelineVelocityDrilldownTableColumnFilterData = (
  state: State,
): SelectedPipelineVelocityDrilldownFilterColumnsData =>
  // @ts-expect-error - TS23339 - Property 'pipelineVelocityDrilldownTableColumnFilter' does not exist on type 'AnalyticsHiringPipelineState'.
  state.analyticsHiringPipeline.pipelineVelocityDrilldownTableColumnFilter ??
  {};
